import { createReducer } from 'reduxsauce';

import { InvoicePicklistReportTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const invoicePicklistReportLoading = (state, { boolean }) => ({
  ...state,
  reportIsLoading: boolean
});

export const invoicePicklistReportFetchSuccess = (
  state,
  { criteria, sorts, reportData, pagination }
) => ({
  ...state,
  criteria,
  sorts,
  reportData,
  pagination
});

export const invoicePicklistReportExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const reducer = createReducer(INITIAL_STATE, {
  [InvoicePicklistReportTypes.INVOICE_PICKLIST_REPORT_LOADING]: invoicePicklistReportLoading,

  [InvoicePicklistReportTypes.INVOICE_PICKLIST_REPORT_FETCH_SUCCESS]: invoicePicklistReportFetchSuccess,

  [InvoicePicklistReportTypes.INVOICE_PICKLIST_REPORT_EXPORT_LOADING]: invoicePicklistReportExportLoading
});
